module.exports = __webpack_public_path__ + "media/img/masks/avatar-group-hover-last-ba70611669b351257fedab9368d4ad6b.svg";